import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export class Http {
  constructor(status) {
    // Check if the request requires authentication
    this.isAuth = status && status.auth ? status.auth : false;

    // Create a new Axios instance with the base URL
    this.instance = axios.create({
      baseURL: API_URL,
    });

    // Initialize request interceptor
    return this.init();
  }

  init() {
    if (this.isAuth) {
      // Intercept requests and add authorization token if needed
      this.instance.interceptors.request.use(
        (request) => {
          const token = `Bearer ${localStorage.getItem('token')}`; // Get the token from AuthService

          // If token exists, add it to the request header
          request.headers['Authorization'] = token;

          return request; // Return the modified request
        },
        (error) => {
          return Promise.reject(error); // Handle any request errors
        }
      );
    }

    return this.instance; // Return the axios instance
  }
}
